import React, { useEffect } from 'react';

const GptAgent = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cdn.customgpt.ai/js/chat.js';
    script.defer = true;
    document.body.appendChild(script);

    const inlineScript = document.createElement('script');
    inlineScript.defer = true;
    inlineScript.innerHTML = `
      (function(){
        function init() {
          CustomGPT?.init({
            p_id: '70685',
            p_key: '4a8537331448f4f53f936e27a4d7abfb'
          });
        }
        document.readyState === 'complete' ? init() : window.addEventListener('load', init);
      })();
    `;
    document.body.appendChild(inlineScript);
  }, []);

  return null;
};

export default GptAgent;
